// Import of Relay genereted types.
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports

export var useAppsToRender = function useAppsToRender(payload) {
  // 1 TDOD: Implmenent apps caalcualtion and mapping, if no apps to render return empty array
  // Remeber about stable reference
  // 2 TODO: Impmeleemnt metrics send configuredAppsPerContext
  // 3 TODO: Set UIM/Adjustments are enabled -> isUiModificationsRunning?

  return [];
};